export const Movements = [{
  type: 2,
  name: 'Primary',
  tlabel: 'PRIMARY',
}, {
  type: 1,
  name: 'Secondary',
  tlabel: 'SECONDARY',
},
{
  type: 3,
  name: 'Vendor',
  tlabel: 'VENDOR',
},
{
  type: 4,
  name: 'Return',
  tlabel: 'RETURN',
}];

export const reasonTypeMap = {
  INDENT_EDIT: {
    type: 'INDENT_EDIT',
    name: 'Indent Edit',
    tlabel: 'REASON_INDENT_EDIT',
  },
  INDENT_REINDENT: {
    type: 'INDENT_REINDENT',
    name: 'Indent Reindent',
    tlabel: 'REASON_INDENT_REINDENT',
  },
  INDENT_REJECTION: {
    type: 'INDENT_REJECTION',
    name: 'Indent Rejection ',
    tlabel: 'REASON_INDENT_REJECTION',
  },
  INDENT_CANCEL: {
    type: 'INDENT_CANCEL',
    name: 'Indent Cancel ',
    tlabel: 'REASON_INDENT_CANCEL',
  },
  INDENT_FREIGHT_AMOUNT: {
    type: 'INDENT_FREIGHT_AMOUNT',
    name: 'Indent Freight Amount ',
    tlabel: 'REASON_INDENT_FREIGHT_AMOUNT',
  },
  OPTIMA_EDIT: {
    type: 'OPTIMA_EDIT',
    name: 'Optima Edit',
    tlabel: 'REASON_OPTIMA_EDIT',
  },
  OPTIMA_SPLIT: {
    type: 'OPTIMA_SPLIT',
    name: 'Optima Split',
    tlabel: 'REASON_OPTIMA_SPLIT',
  },
  OPTIMA_COMBINE: {
    type: 'OPTIMA_COMBINE',
    name: 'Optima Combine',
    tlabel: 'REASON_OPTIMA_COMBINE',
  },
  OVERRIDE_VAHAN_SARATHI: {
    type: 'OVERRIDE_VAHAN_SARATHI',
    name: 'Override vahan sarathi reason',
    tlabel: 'REASON_OVERRIDE_VAHAN_SARATHI',
  },
  LR_ATTACHMENT_REJECTION: {
    type: 'LR_ATTACHMENT_REJECTION',
    name: 'LR Attachment Rejection reason',
    tlabel: 'REASON_LR_ATTACHMENT_REJECTION',
  },
  TRUCK_CHANGE_REQUEST: {
    type: 'TRUCK_CHANGE_REQUEST',
    name: 'Truck change request reason',
    tlabel: 'TRUCK_CHANGE_REQUEST',
  },
  SHIPMENT_DELAY: {
    type: 'SHIPMENT_DELAY',
    name: 'Shipment Delay reason',
    tlabel: 'Shipment Delay',
  },
  DISCREPANCY_CATEGORY: {
    type: 'DISCREPANCY_CATEGORY',
    name: 'Discrepancy Category reason',
    tlabel: 'Discrepancy Category',
    subTypes: [
      { value: 'shortage', label: 'Shortage' },
      { value: 'damage', label: 'Damage' },
      { value: 'carton_damage', label: 'Carton Damage' },
      { value: 'leakage', label: 'Leakage', feature: 'show_grn_excess' },
      { value: 'excess', label: 'Excess', feature: 'show_grn_excess' },
    ],
  },
};

export const ReasonTypes = Object.values(reasonTypeMap);

export const indentEditOptions = [{
  value: 'Truck type not available with transporter',
  key: 'TRUCK_TYPE_NOT_AVAILABLE',
}, {
  value: 'Transporter not available',
  key: 'TRANSPORTER_NOT_AVAILABLE',
}, {
  value: 'Transporter not responsive',
  key: 'TRANSPORTER_NOT_RESPONSIVE',
}];

export const reIndentReasonOptions = [{
  value: 'Lack of availability of truck with transporter',
  key: 'TRANSPORTER_NOT_AVAILABLE',
}, {
  value: 'No Response from transporter',
  key: 'TRANSPORTER_NOT_RESPONSIVE',
}, {
  value: 'Transporter doesn’t agree on contracted rate and wants to renegotiate',
  key: 'TRANSPORTER_RENEGOTIATED',
}];

export const indentRejectOptions = [
  { value: 'Vehicle type is not available in market', key: 'INDENT_REJECT_VEHICLE_TYPE_NA' },
  { value: 'Existing rates are not competitive', key: 'INDENT_REJECT_EXISTING_RATE_ARE_NOT_COMPETITIVE' },
  { value: 'Lane is not serviceable today', key: 'INDENT_REJECT_LANE_NOT_SERVICEABLE' },
];

export const optimaSplitCombineReasons = [
  {
    value: 'Vehicle type unavailable',
    key: 'VEHICLE_TYPE_UNAVAILABLE',
  },
  {
    value: 'Vehicle type cannot access consignee location',
    key: 'VEHICLE_TYPE_CANNOT_ACCESS_CONSIGNEE_LOCATION',
  },
  {
    value: 'Cannot combine consignee(s)',
    key: 'CANNOT_COMBINE_CONSIGNEE',
  },
  {
    value: 'Too many delivery splits (leading to multiple invoices)',
    key: 'TOO_MANY_DELIVERY_SPLITS',
  },
  {
    value: 'A larger truck is available for upsizing and dispatching',
    key: 'LARGER_TRUCK_IS_AVAILABLE_FOR_UPSIZE_AND_DISPATCHING',
  },
  {
    value: 'The transporter has not responded to the request.',
    key: 'TRANSPORTER_HAS_NOT_RESPONDED_TO_REQUEST',
  },
];

export const optimaEditReasons = [
  {
    value: 'Vehicle type not available with transporter',
    key: 'VEHICLE_TYPE_NOT_AVAILABLE_WITH_TRANSPORTER',
  },
  {
    value: 'No response from Transporter',
    key: 'NO_RESPONSE_FROM_TRANSPORTER',
  },
];

export const freightAmountReasons = [
  {
    value: 'No available transporters in the lane',
    key: 'NO_AVAILABLE_TRANSPORTER_IN_THE_LANE',
  },
  {
    value: 'No available truck types in the lane',
    key: 'NO_AVAILABLE_TRUCK_TYPES_IN_THE_LANE',
  },
];

export const truckTypeChangeReasons = [
  {
    value: 'The specified truck type has limited availability in the market',
    key: 'VEHICLE_TYPE_LIMITED_AVAILABILITY',
  },
  {
    value: 'This is an urgent order, and I require prompt dispatch',
    key: 'URGENT_ORDER_NEED_TO_DISPATCH',
  },
];

export const overrideReasonOptions = [
  {
    value: 'Vehicle Details not updated in VAHAN',
    key: 'VAHAN_DETAILS_NOT_UPDATED',
  },
  {
    value: 'Driver Details not updated in SARATHI',
    key: 'SARATHI_DETAILS_NOT_UPDATED',
  },
];
